import { render, staticRenderFns } from "./UserSecuritySettings.vue?vue&type=template&id=7bcce738"
import script from "./UserSecuritySettings.vue?vue&type=script&lang=js"
export * from "./UserSecuritySettings.vue?vue&type=script&lang=js"
import style0 from "./UserSecuritySettings.vue?vue&type=style&index=0&id=7bcce738&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports